import {Campaign} from '../../_models/Campaign'
import { toast } from 'react-toastify';
import * as Moment from 'moment'

  export function updateCampaign(this:any, event:any) {
    event.preventDefault()
    this.setState({updating: true})

    let formData = new FormData();
    for (let key in this.state.campaign) {
      if (this.state.campaign[key] !== null && key != "images") {
        let value = this.state.campaign[key]
        if(typeof(value) == 'object' && value.length > 0) {
          value = JSON.stringify(value)
        }
        formData.append(key, value);
      }
    }


    if (this.brief.files.length > 0) {
      formData.set("brief", this.brief.files[0]);
    }

    if (this.images.length > 0) {
      for (var x = 0; x < this.images.length; x++) {
          formData.append("images", this.images[x]);
      }
    }

    if (this.logo.files.length > 0) {
      formData.set("logo", this.logo.files[0]);
    }

    formData.append("accountType", window.account.type || "")
    formData.append("accountId", window.account.id || "")

    formData.set("deadline", this.state.campaign.deadline.format("DD/MM/YYYY"));
    formData.set("startDate", this.state.campaign.startDate.format("DD/MM/YYYY"));
    formData.set("endDate", this.state.campaign.endDate.format("DD/MM/YYYY"));
    fetch('campaigns/edit', {
      method: 'POST',
      body: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      },
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaign = new Campaign(data.campaign)
        campaign.updated = true
        toast.success("קמפיין עודכן")
        this.props.history.push("/campaigns")
    }).catch(err => {
      toast.error(err.message);
      this.setState({updating: false})
    })


  }

  export function removeCampaign(this:any, id: number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('campaigns/delete', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let campaigns = this.state.campaigns
      campaigns.splice(index, 1)
      this.setState({campaigns})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  export function completeCampaign(this:any, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('campaigns/complete', {
      method: 'POST',
      body: JSON.stringify({id: this.state.campaign.id})
    }).then((response: any) => {
      this.props.history.push("/campaigns/")
    }).catch(err => {
      toast.error(err.message);
    })
  }

  export function activeCampaign(this:any, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return
    fetch('campaigns/active', {
      method: 'POST',
      body: JSON.stringify({id: this.state.campaign.id})
    }).then((response: any) => {
      this.props.history.push("/campaigns/")
    }).catch(err => {
      toast.error(err.message);
    })
  }

  export function exportCampaign(this:any, event:any) {
    event.preventDefault()
    fetch('campaigns/export', {
      method: 'POST',
      body: JSON.stringify({id: this.state.campaign.id})
    }).then((response: any) => {
      return response.blob()
    }).then((blob: any) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.style.display = "none"
      a.href = url;
      a.download = "campaign_"+this.state.campaign.id+".csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }).catch(err => {
      toast.error(err.message);
    })
  }


  export function changeClient(this:any, selectedOption:any) {
    this.setState({ selectedOption }, () => {
      if(selectedOption.value) {
        let campaign = this.state.campaign
        campaign.updated = false
        campaign.clientId = selectedOption.id
        campaign.client = selectedOption
        this.setState({campaign})
      } else {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      }
    });
  }

  export function changeMediaType(this:any, selectedOption:any) {
    this.setState({ selectedOption }, () => {
      if(selectedOption.value) {
        let campaign = this.state.campaign
        campaign.updated = false
        campaign.mediaType = selectedOption.value
        this.setState({campaign})
      } else {
        let campaign = this.state.campaign
        campaign.updated = false
        this.setState({campaign})
      }
    });
  }



  export function changeDate(this:any, name:string, date:any) {
    let campaign = this.state.campaign
    campaign[name] = Moment(date)
    campaign.updated = false
    this.setState({campaign})
  }




  export function handleCampaignChange(this:any, event: any) {
    let campaign = this.state.campaign
    campaign[event.target.name] = event.target.value
    campaign.updated = false
    this.setState({campaign});
  }

  export function addUser(this:any, selectedOption:any, event: any) {
    let campaign = this.state.campaign
    let found = false

    found = campaign.users.find((user:any) => {
      return user.id==selectedOption.id
    })
    if(!found) {
      campaign.users.push(selectedOption)
      campaign.updated = false
      this.setState({campaign, usersFiltered: campaign.users})
    } else {
      toast.warn("משפיען כבר קיים בקמפיין")
    }
  }

  export function removeUser(this:any, campaignUserId:number, userId:number, index: number, event: any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return

    if(this.state.campaign.id && campaignUserId) {
      fetch('campaigns/deleteUser', {
        method: 'POST',
        body: JSON.stringify({userId, campaignId: this.state.campaign.id})
      }).then(() => {
        let campaign = this.state.campaign
        campaign.users.splice(index, 1)
        this.setState({campaign, usersFiltered: campaign.users})
      }).catch(err => {
        toast.error(err.message);
      })
    } else {
      let campaign = this.state.campaign
      campaign.users.splice(index, 1)
      this.setState({campaign, usersFiltered: campaign.users})
    }
  }


  export function removeImage(this:any, id:number, index: number, event:any) {
    event.preventDefault()
    let confirmed = confirm("האם אתה בטוח?")
    if(!confirmed) return

    fetch('campaigns/deleteImage', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(() => {
      let campaign = this.state.campaign
      campaign.images.splice(index, 1)
      this.setState({campaign})
    }).catch(err => {
      toast.error(err.message);
    })

  }

  export function removeBrief(this:any, event: any) {
    event.preventDefault()
    let campaign = this.state.campaign
    campaign.updated = false
    campaign.brief = ""
    this.setState({campaign})
  }

  export function editCampaignUser(this:any, id: number, event:any) {
    let name = event.target.name
    let value = event.target.value
    let campaign = this.state.campaign
    let usersFiltered = this.state.usersFiltered

    let users = campaign.users.map((user:any) => {
      if(user.id == id) user[name]=value
      return user
    })

    let newUsersFiltered = usersFiltered.map((user:any) => {
      if(user.id == id) user[name]=value
      return user
    })

    campaign.users = users
    campaign.updated = false
    this.setState({campaign, usersFiltered: newUsersFiltered})
  }
  export function addBrief(this:any, event: any) {
    event.preventDefault()
    let brief = this.brief.files[0].name
    let campaign = this.state.campaign
    campaign.updated = false
    this.setState({campaign, brief})
  }

  export function addImage(this:any, event: any) {
    let image = this.image.files[0]
    if(!image) return
    this.images.push(image)
    var reader = new FileReader();
    let campaign = this.state.campaign
    campaign.updated = false
    reader.onload = (e: any) => {
       if(e.target) {
         campaign.images.push({url: e.target.result})
         this.setState({campaign})
       }
     }
     reader.readAsDataURL(image);
  }



export function handleTagChange(this: any, tags: any) {
  let campaign = this.state.campaign
  campaign.tags = tags
  this.setState({ campaign });
};

export function handleAdminChange(this: any, admins: any) {
  let campaign = this.state.campaign
  let removedAdmin = campaign.admins.filter((x:any) => {return !admins.includes(x)}); // calculates diff
  campaign.updated = false
  campaign.admins = admins

  if(removedAdmin.length && !removedAdmin[0].new) {
    fetch('campaigns/deleteAdmin', {
      method: 'POST',
      body: JSON.stringify({id: removedAdmin[0].id, campaignId: campaign.id})
    }).then(() => {
      this.setState({ campaign });
    }).catch(err => {
      toast.error(err.message);
    })
  } else {
    this.setState({ campaign });
  }


};
export function handleInputChange(this:any, tagValue: string) {
  this.setState({ tagValue });
};
export function handleKeyDown(this:any, event: any) {
  let { tagValue, campaign } = this.state;
  if (!tagValue) return;

  switch (event.key) {
    case 'Enter':
    case 'Tab':

      let found = false
      found = campaign.tags.find((tag:any) => {return tag.label==tagValue})

      if(!found) {
        campaign.updated = false
        campaign.tags.push({label:tagValue, value:tagValue})
        this.setState({tagValue: '',campaign});
      } else {
        toast.warn("האשטאג כבר קיים")
      }

      event.preventDefault();
  }
};

export function filterInfluncers(this: any, selectedOption:any) {
  this.setState({selectedCategory: {id: selectedOption.value, title: selectedOption.label}}, () => {
    let categoryId = selectedOption.value
    let users = this.state.campaign.users
    let usersFiltered = users.filter((user:any) => {
      let filter = false
      if(user.categories) {
        user.categories.map((category: any) => {
          if(category.id == categoryId) filter = true
        })
        return filter
      } else {
        return true
      }


    })
    this.setState({usersFiltered})
  })

}

export function addInfluncerByCategory(this: any, selectedOption:any) {
  let categoryId = selectedOption.value
  let campaign = this.state.campaign
  this.state.users.map((user:any) => {
    user.categories.map((category: any) => {
      if(category.id == categoryId) {
        let found = campaign.users.find((campaignUser: any) => {return campaignUser.id == user.id})
        if(!found) {
          campaign.users.push(user)
          campaign.updated = false
        }
      }
    })
  })

  this.setState({campaign, usersFiltered: campaign.users})
}



// WEBPACK FOOTER //
// ./src/pages/campaign/controller.tsx